import React, { useEffect } from 'react';
import moment from 'moment';
import { Column, FilterFn } from '@tanstack/react-table';
import { translateIncidentStatus } from '@@/constants/incident';

export function Filter({ column }: { column: Column<any, unknown> }) {
  const columnFilterValue = column.getFilterValue();

  return (
    <DebouncedInput
      className="border shadow rounded text-center w-20 sm:w-24 mx-0.5 text-xs text-slate-500"
      onChange={(value) => column.setFilterValue(value)}
      placeholder="Recherche..."
      type="text"
      value={(columnFilterValue ?? '') as string}
    />
  );
}

export function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}: {
  value: string | number;
  onChange: (value: string | number) => void;
  debounce?: number;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>) {
  const [value, setValue] = React.useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value]);

  return (
    <input
      {...props}
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export const dateMatchFilter: FilterFn<any> = (row, columnId, filterValue) => {
  if (!filterValue) {
    return true;
  }

  const cellValue = String(row.original[columnId]);

  return !!moment(cellValue)
    .format('lll')
    ?.toLowerCase()
    ?.includes(filterValue?.toLowerCase());
};

export const propertyNameMatchFilter: FilterFn<any> = (
  row,
  _columnId,
  filterValue,
) => {
  if (!filterValue) {
    return true;
  }

  const cellValue = row.original.propertyId?.name;

  return !!cellValue?.toLowerCase()?.includes(filterValue?.toLowerCase());
};

export const buildingNameMatchFilter: FilterFn<any> = (
  row,
  _columnId,
  filterValue,
) => {
  if (!filterValue) {
    return true;
  }

  const cellValue = row.original.creator?.buildingName;

  return !!cellValue?.toLowerCase()?.includes(filterValue?.toLowerCase());
};

export const apartmentNumberMatchFilter: FilterFn<any> = (
  row,
  _columnId,
  filterValue,
) => {
  if (!filterValue) {
    return true;
  }

  const cellValue = row.original.creator?.apartmentNumber;

  return !!cellValue?.toLowerCase()?.includes(filterValue?.toLowerCase());
};

export const statusMatchFilter: FilterFn<any> = (
  row,
  columnId,
  filterValue,
) => {
  if (!filterValue) {
    return true;
  }

  const cellValue = String(row.original[columnId]);

  return !!translateIncidentStatus(cellValue)
    ?.toLowerCase()
    ?.includes(filterValue?.toLowerCase());
};
